module.exports = __webpack_public_path__ + "img/logo-cromatic.de0ec56d.png";